// @flow

import React from "react";
import "./form-view.scss";

export type FormViewItem = [string, string];

export type FormViewProps = $Exact<{
  data: Array<FormViewItem>,
}>;

const FormView = (props: FormViewProps) => (
  <div className="formview__container">
    {props.data
      ? props.data.map(([k, v]: FormViewItem) => (
          <div key={k} className="formview__row">
            <div className="formview__key">{k}</div>
            <div className="formview__value">{v}</div>
          </div>
        ))
      : null}
  </div>
);

export default FormView;
